module.exports = __webpack_public_path__ + "a046b7d1e825adadbd3b52f6cd08c56c.pdf";